module.exports = __webpack_public_path__ + "img/MIELHONEY.b76c9525.png";